export default __webpack_public_path__ + "static/media/camera_white.ececafa3.svg";